import type { DictionaryResponse } from '@/shared/types/dictionaryTypes';
import { apiClient } from '../apiClient';
import { handleRequest } from '../apiWrapper';

export const getDictionary = async <TDictionaryValue>(dictId: string) => {
  const request = () => apiClient.get(`/dictionaries/${dictId}`);
  const response =
    await handleRequest<DictionaryResponse<TDictionaryValue>>(request);
  return response.data;
};
